import { router } from "@inertiajs/react";
import { resetClientState } from "@/lib/resetClientState";

export function signOut(): void {
  void resetClientState();
  router.delete("/users/sign_out");
}
